// Utilities
import { builderFetch } from '@builder/core/utilities';
const { isEmpty } = _uo.utility;

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.item.duplicateAction;

/**
 * Duplicates an action
 *
 * @param {Number} itemId The item ID
 * @return {Promise} The apiFetch promise
 */
const duplicateAction = ( itemId ) => {
	// Get the item
	const item = UncannyAutomator._core.recipe.item.getItem( 'action', itemId );

	// If the item is not define, stop here
	if ( isEmpty( item ) ) {
		throw new Error( `duplicateAction: The action ${ itemId } doesn't exist` );
	}

	// Save the recipe title
	return builderFetch( {
		endpoint: 'duplicate_action',
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			recipe_id: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			action_id: itemId,
		},
		snackbar: {
			loading: strings.duplicatingAction,
			success: strings.actionDuplicated,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/item/duplicate-action', {
				detail: {
					actionID: itemId
				}
			} ) );
		}

		return response;
	} );
}

export default duplicateAction;
